export default "__VITE_ASSET__zGw0pnpd__"